import { render } from "./GabineteAgendaStatusSelect.vue?vue&type=template&id=e252349e"
import script from "./GabineteAgendaStatusSelect.vue?vue&type=script&lang=js"
export * from "./GabineteAgendaStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__